export const MENU = {
    SET_MENU: 'SET_MENU',
    SET_CHOIX_MENU: 'SET_CHOIX_MENU',
    SET_SITES: 'SET_SITES',
    SET_ONBOARDING_OPEN: 'SET_ONBOARDING_OPEN',
    SET_STATUT_BIM: 'SET_STATUT_BIM',
};
